module.exports = __webpack_public_path__ + "media/10zl.702ed99d.mp3";